import React, {useEffect} from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import {toggleProductNoteEditorVisible} from "../../actions/selectionFunctions";
import Analytics from '../../analytics';

const AddProductNoteButton = (props) => {
  const {productNoteEditorVisible, toggleProductNoteEditorVisible, selectionFeatureInfo, activeQuoteIndex,
    cartItemEditFeature} = props;

  // while editing a cart item the editor works with that cart item's note, not the feature's one
  const hasNote = cartItemEditFeature
    ? !!cartItemEditFeature.noteText
    : !!selectionFeatureInfo?.notesList[activeQuoteIndex];

  useEffect(() => {
    return () => {
      toggleProductNoteEditorVisible(false);
    }
  }, [] ); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = () => {
    Analytics.sendClickEvent('note-add-edit');
    toggleProductNoteEditorVisible(!productNoteEditorVisible);
  };

  return (
    <button className={"product-note__button--add-note ui-add-note" + (productNoteEditorVisible ? " ui-add-note--active" : "")}
            onClick={handleClick}>
      <FormattedMessage id={hasNote
        ? "quotingTool.featureInfo.editNoteButton"
        : "quotingTool.featureInfo.addNoteButton"}/>
    </button>
  )
};

const mapStateToProps = (store) => {
  const {productNoteEditorVisible, selectionFeatureInfo} = store.selectionState;
  return {
    selectionFeatureInfo,
    productNoteEditorVisible,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    cartItemEditFeature: store.cartState.cartItemEditFeature,
  };
};

const mapDispatchToProps = {
  toggleProductNoteEditorVisible
};

export default connect(mapStateToProps, mapDispatchToProps)(AddProductNoteButton);
